module.exports = __webpack_public_path__ + "img/add.0d4e63e1.svg";